class ProductMainGallery extends HTMLElement {
  constructor() {
    super();
    this.setupArrows();
  }

  setupArrows() {
    const prevButtons = this.querySelectorAll('.product-main-image-arrow--prev');
    const nextButtons = this.querySelectorAll('.product-main-image-arrow--next');

    prevButtons.forEach(button => {
      button.addEventListener('click', () => this.navigate(-1));
    });

    nextButtons.forEach(button => {
      button.addEventListener('click', () => this.navigate(1));
    });
  }

  navigate(direction) {
    const slides = Array.from(this.querySelectorAll('.product__media-item'));
    const activeSlide = this.querySelector('.product__media-item.is-active');
    
    if (!activeSlide || slides.length === 0) return;
    
    const currentIndex = slides.indexOf(activeSlide);
    let nextIndex = currentIndex + direction;

    // Loop around
    if (nextIndex < 0) nextIndex = slides.length - 1;
    if (nextIndex >= slides.length) nextIndex = 0;

    const nextSlide = slides[nextIndex];
    
    // Remove active class from all
    slides.forEach(slide => slide.classList.remove('is-active'));
    
    // Add active class to next
    nextSlide.classList.add('is-active');
    
    // Update thumbnails if they exist
    this.updateThumbnails(nextSlide);
    
    // Scroll into view
    nextSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  updateThumbnails(activeSlide) {
    const mediaId = activeSlide.getAttribute('data-media-id');
    const thumbnails = document.querySelectorAll('[data-target]');
    
    thumbnails.forEach(thumb => {
      if (thumb.getAttribute('data-target') === mediaId) {
        thumb.classList.add('is-active');
        thumb.querySelector('button')?.setAttribute('aria-current', 'true');
      } else {
        thumb.classList.remove('is-active');
        thumb.querySelector('button')?.removeAttribute('aria-current');
      }
    });
  }
}

customElements.define('product-main-gallery', ProductMainGallery);